@if (agent$ | async; as agent) {
  <p class="text-balance text-black/60">
    Treine seu agente para atender seus contatos.
    <a
      href="https://home.blu.direct/blog/como-criar-instrucoes-para-agentes-ia-no-blu"
      target="_blank"
      class="font-bold text-accent-600"
      >Saiba mais</a
    >.
  </p>
  <!-- name -->
  <input placeholder="Nome" [(ngModel)]="agent.name" />
  <!-- instructions -->
  <textarea
    placeholder="Instruções do agente"
    [(ngModel)]="agent.configuration.prompt"
    class="resize-none flex-1 min-h-80"
    [disabled]="formattingText"
  ></textarea>
  <!-- format with ai -->
  <p class="flex items-center gap-3 text-black/60">
    @if (!formattingText) {
      <button
        class="ai p-1"
        [disabled]="
          !agent.configuration.prompt ||
          formattedText() === agent.configuration.prompt
        "
        (click)="formatText()"
      >
        <span class="material-symbols-rounded"> auto_awesome </span>
      </button>
    } @else {
      <kor-spinner class="w-fit h-fit"></kor-spinner>
    }
    Melhore suas instruções usando Inteligência Artificial.
  </p>
}
